const ProgressionPoint = ({ activeClass, notAchievedClass }) => (
  <div
    className={`repair-status-progress-point ${activeClass} ${notAchievedClass}`}
  />
);

export default ProgressionPoint;
